/**
 * @file User / material analysis UI — pages/Dashboard/User/Home/components/DataSpecificitySection.tsx.
 */

import React from "react";
import "../UserHome.css";

const DataSpecificitySection: React.FC = () => {
  return (
    <div className="user-home-section">
      <h2 className="user-section-heading">Understanding data specificity</h2>
      
      <div className="user-info-card">
        <h3 className="user-info-card-title">Generic specificity data</h3>
        <p className="user-info-card-text">
          Generic specificity data refers to reliable datasets that represent a broad range of conditions, including: randomized temporal ranges, broad geographical coverage, multiple technologies and manufacturers.
        </p>
        <p className="user-info-card-text">
          This data type is useful when project-specific constraints are not yet fixed.
        </p>
      </div>

      <div className="user-info-card">
        <h3 className="user-info-card-title">Defined specificity data</h3>
        <p className="user-info-card-text">
          If you are looking for specific data, ICOMEC allows you to define data specificity based on predefined project requirements. Defining specificity increases data relevance but may reduce sample size depending on data availability.
        </p>
        <p className="user-info-card-text">
          You may refine the dataset using one or more of the following parameters:
        </p>
      </div>
    </div>
  );
};

/** React component — Data Specificity Section. */
export default DataSpecificitySection;
